let searchTimeoutId = null;

const siezeReplacements = {
  chico: "ch",
  mediano: "M",
  grande: "G",
  "extra grande": "XG",
};

const search = {
  pageSize: 20,
  modalSize: 8,
  isWaiting: false,
  container: document.getElementById("search-results"),
  input: document.getElementById("search-query"),
  sortBy: document.getElementById("sort-by"),
  isModal: document.querySelector(".search-modal") !== null,
  current: {
    query: null,
    from: 0,
  },
  get: () => {
    let sort = null;
    if (!search.isModal) {
      switch (search.sortBy.value) {
        case "price-descending":
          sort = { field: "price", order: "desc" };
          break;
        case "price-ascending":
          sort = { field: "price", order: "asc" };
          break;
        default:
          sort = null;
          break;
      }
    }
    const queryRaw = search.input.value;
    const querySizes = queryRaw.replace(
      new RegExp(Object.keys(siezeReplacements).join("|"), "gi"),
      (match) => {
        return siezeReplacements[match.toLowerCase()];
      }
    );
    nostojs((api) => {
      if (querySizes != search.current.query) search.current.from = 0;
      api
        .search(
          {
            query: querySizes,
            products: {
              facets: search.isModal ? [] : ["*"],
              filter: search.isModal
                ? []
                : querySizes != search.current.query
                ? []
                : search.facets.list,
              fields: ["name", "imageUrl"],
              size: search.isModal ? search.modalSize : search.pageSize,
              sort: sort,
              ////TODO check this
              from: search.current.from,
              // useVectorSearch: true,
              // useQuerySynonyms: true
            },
            // keywords: { fields: ["keyword"] },
          },
          {
            redirect: true,
            track: "serp",
            // isKeyword: true,
          }
        )
        .then((response) => {
          if (
            !search.isModal &&
            search.current.query != response.query &&
            response.products.facets?.length > 0
          ) {
            search.facets.container.innerHTML = "";
            for (const customFacet of response.products.facets) {
              if (customFacet.name != "shasa-color") {
                search.facets.container.innerHTML += `
                  <details class="facets__details">
                    <summary>
                      <h4 class="facets__details-title">
                        ${customFacet.name}
                      </h4>
                      <svg class="icon icon-filter-two" width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10 1.5L6 5.5L2 1.5" stroke="currentColor" stroke-width="2" stroke-linecap="square"/>
                      </svg>
                    </summary>
                    <fieldset class="facets-wrap parent-wrap">
                      <ul class="facets__list">
                        ${customFacet.data
                          .map((facet) => {
                            const replacedFacet = facet.value
                              .trim()
                              .replace(/[^a-zA-Z]/g, "")
                              .toLowerCase();
                            const facetName =
                              facets.es[replacedFacet] || facet.value;
                            return `
                            <li class="list-menu__item facets__item" title="${"value.label"}">
                              <label class="facets-checkbox">
                                <input type="checkbox" class="facets-checkbox__hide" onchange="search.facets.set('${
                                  customFacet.field
                                }', '${facet.value}', this.checked)">
                                <span class="facets-checkbox__marker">
                                  <svg width="12" height="10" class="icon icon-facets-checkmark" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M2 4.82353L4.76923 8L10 2" stroke="currentColor" stroke-width="2" stroke-linecap="square"/>
                                  </svg>
                                </span>
                                <span class="facets-checkbox__label">
                                  ${facetName}
                                </span>
                              </label>
                            </li>
                          `;
                          })
                          .join("")}
                      </ul>
                    </fieldset>
                  </details>
                `;
              }
            }
          }
          if (response.products.hits.length > 0) {
            if (search.current.from == 0) {
              search.container.innerHTML = "";
            }
            for (const hit of response.products.hits) {
              const container = document.createElement("div");
              //// nsc = nosto search card
              const id = `card-${hit.productId}`;
              container.id = id;
              search.container.appendChild(container);
              new Card(hit.productId, id, "nostosearch");
            }
          } else if (search.current.from == 0) {
            search.container.innerHTML = "<h2>Sin resultados</h2>";
          }
          search.current.query = response.query;
        });
    });
  },
  clear: () => {
    search.input.value = "";
    search.container.innerHTML = "";
  },
  facets: {
    container: document.querySelector(".facets__details__wrapper"),
    list: [
      {
        field: "skus.customFields.talla",
        value: [],
      },
      {
        field: "customFields.shasa-color",
        value: [],
      },
      {
        field: "customFields.custom-fits",
        value: [],
      },
      {
        field: "customFields.custom-product_group_code",
        value: [],
      },
      {
        field: "customFields.custom-color",
        value: [],
      },
    ],
    set: (name, value, checked) => {
      const facet = name.split(".").at(-1);
      const position = search.facets.list.findIndex((f) =>
        f.field.includes(facet)
      );
      const valueUppercase = value.toUpperCase();
      if (checked) {
        search.facets.list[position].value.push(valueUppercase);
      } else {
        search.facets.list[position].value = search.facets.list[
          position
        ].value.filter((v) => v != valueUppercase);
      }
      search.get();
    },
  },
  open: (id, url) => {
    nostojs((api) => {
      api.recordSearchClick("serp", { productId: id, url: url });
    });
    location.href = url+"?fromnostosearch=true";
  },
  loadMore: () => {
    if (!search.isWaiting) {
      search.isWaiting = true;
      search.current.from += search.pageSize;
      search.get();
      setTimeout(() => {
        search.isWaiting = false;
      }, 1500);
    }
  },
  sort: () => {
    search.current.from = 0;
    search.get();
  },
};

const url = new URL(window.location.href);
if (url.pathname.includes("search")) {
  const urlQuery = url.searchParams.get("q");
  if (urlQuery) search.get();
  search.input.addEventListener("keydown", (event) => {
    if (event.key === "Enter") {
      search.get();
    }
  });
  window.addEventListener("scroll", () => {
    const rect = search.container.getBoundingClientRect();
    if (rect.bottom <= window.innerHeight) search.loadMore();
  });
} else {
  search.input.addEventListener("input", () => {
    clearTimeout(searchTimeoutId);
    searchTimeoutId = setTimeout(() => search.get(), 300);
  });
}
